// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"592e6685","973":"0f0a35c0"}[chunkId] + ".chunk.css";
};